module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('img', {
    staticClass: "imagefw",
    attrs: {
      "alt": "Images",
      "src": "images/common1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Kelly made her way up the stairs, the floorboards of their renovated farmhouse creaking under her weight. Her bedroom was down the hall to the right. A vision in pink and green.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d begged her parents all year to let her redecorate, but her mom refused. She couldn’t accept that Kelly had long since outgrown the plaid decor she had picked out when Kelly was still crawling. Kelly had the feeling she’d be living in preppy paradise until she left for college.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("She tossed her book bag on the carnation-pink carpet, next to the rolled-up pair of jeans she’d tried on, then rejected, this morning. Pulling out the white chair that matched her desk set, she booted up her laptop, then quickly IMed Paige and June.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Kookykell2011: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("I")]), _vm._v(". B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD NEWS")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: ?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O SLEEPOVER TONIGHT")]), _vm._v(". P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARENTS TRAPPED IN SNOW IN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILLY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEARD")]), _vm._v(". C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN’T BELIEVE YOUR MOM THINKS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISSIE IS GONNA KEEP U SAFE")]), _vm._v("! LOL")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PARE ME")]), _vm._v(". S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O NOT MY IDEA")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: U "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAVE A BABYSITTER")]), _vm._v("!!!???!! C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISSIE")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT MY IDEA")]), _vm._v("!!!!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T IS KINDA SCARY AT NIGHT ALONE")]), _vm._v(" . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOOOOH")]), _vm._v("! B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER WATCH OUT")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT SCARED")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT ABOUT YOUR SLEEPOVER")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAH")]), _vm._v(". I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAVE A PRESENT")]), _vm._v(" 4 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("U")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" 2.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HX")]), _vm._v(". U "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GUYS R THE BEST")]), _vm._v(". I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAVE TO MOVE IT TO NEXT WEEKEND")]), _vm._v(". S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TINKS")]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD SO MANY GREAT SCARES PLANNED FOR U TONIGHT")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Paige4peace421: M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYBE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("’M SAFER AT HOME")]), _vm._v("! H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("A HA")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sudden, terrified shriek filled the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ryan pounded up the stairs, taking them two at a time. “Kelly!” he cried. He burst into her room.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("“What’s wrong?” she asked, pushing back in her chair to see him.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look what I found.” He gingerly held up what appeared to be a severed finger wrapped in a napkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ooh, gross.” She shrank back. She could see all the tiny wrinkles in the skin and the nail still in place on the end. So alive. So real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t act all innocent,” he said. “I know it was you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about?” she asked. “Are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ryan sneered. “Like you care.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kelly raised her eyebrows in confusion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you’re the one who stuck this fake finger in the cookie package.” Ryan’s face reddened in anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s scary when kids get too greedy. Got to keep your fingers out of the cookie jar, as some people say.” Kelly couldn’t hide her triumphant grin. Ryan was such an easy target for a scare. There really was no sport in it. He fell for her frights every time. After all these years, she would’ve thought he’d wise up. But she was glad he stayed so gullible. She loved hearing his frightened cries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha-ha.” He turned to leave. “I’m watching TV. Leave me alone tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Gladly,” she replied, swiveling back to her screen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SpenceX77: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Kookykell2011: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spencer Stone logged onto their chat session. Kelly filled him in on the blizzard situation. He lived across the street from Kelly, and Paige lived behind her house. June Prendergast was only around the block. The four had been friends since tricycle days. There was a goofy photo of them all squeezed into a red wagon around age three in a frame on her desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Kelly’s cell buzzed, and she wiggled her shiny blue phone out of her jeans pocket. There was a voice mail. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("This phone has the worst service,")]), _vm._v(" she thought. As Paige and June greeted Spencer, she listened to the long message from her mom. They had arrived at the motel, and her mom wasn’t happy. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("That makes two of us,")]), _vm._v(" Kelly thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("She’s not getting any sympathy from me.")]), _vm._v(" Then she grinned. Her mother’s story gave her an idea. She instantly knew how to add lots of spooky touches to really freak out her friends. A classic Kelly scare. Her fingers flew over the keyboard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Kookykell2011: Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU GUYS WON’T BELIEVE WHAT JUST HAPPENED TO MY PARENTS")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE TAXI LET THEM OFF IN FRONT")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F A RUN-DOWN BUILDING ON THE FAR EDGE OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILLY")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ENTIRE STREET WAS BLANKETED IN DRIFTS OF SNOW")]), _vm._v(". E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VEN IN THE STORM, MY MOM COULD SEE THIS WAS THE KIND OF PLACE YOU ONLY CHECKED INTO IF YOU WERE DESPERATE, WHICH THEY WERE")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE BRICKS WERE CRACKED, THICK DUST LINED THE WINDOWS, AND THE ROOF SLUMPED IN AT A DANGEROUS ANGLE")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE TAXI PULLED AWAY, DISAPPEARING DOWN THE STREET, LEAVING THEM ALONE")]), _vm._v(". E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYTHING WAS COMPLETELY SILENT")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERE WERE NO OTHER CARS")]), _vm._v(". N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O SOUNDS")]), _vm._v(". N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHING")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: OMG! D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ID THEY GO IN")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOULDN’T")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY HAD NO CHOICE")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY PUSHED OPEN THE HEAVY WOODEN DOOR AND STEPPED INTO COMPLETE BLACKNESS")]), _vm._v(". N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O LIGHTS")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY CALLED OUT BUT GOT NO ANSWER")]), _vm._v(". M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y FATHER REACHED AROUND DESPERATELY FOR A LIGHT SWITCH")]), _vm._v(". S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OON HIS FINGERS FELT ONE, AND HE FLICKED IT ON AND . . . BEHIND THE FRONT DESK SAT A SKELETON")]), _vm._v(". W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO KNEW HOW LONG THE BODY HAD BEEN THERE, ROTTING AWAY")]), _vm._v("? T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FLESH HAD DECOMPOSED AND ONLY THE BONES REMAINED . . . SITTING THERE, WAITING TO GREET THE GUESTS")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN THE MOTEL PHONE RANG")]), _vm._v(". I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T RANG AND RANG")]), _vm._v(". M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y FATHER TOOK A HESITANT STEP FORWARD AND LIFTED THE RECEIVER")]), _vm._v(". H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLO? HE SAID")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("SpenceX77: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO WAS CALLING")]), _vm._v("? W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT DID THEY SAY")]), _vm._v("?????")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("Kookykell2011: H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E SAID")]), _vm._v(" GOTCHA! K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLY RULES")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("She laughed as her friends typed back, annoyed that she had done it again.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Kookykell2011: I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM THE")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UEEN OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CARES")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d been scaring her friends for years. In elementary school, she was mostly about fake snakes and eyeballs. And while those were still awesome, especially when skillfully placed in a lunch bag, she’d moved on in middle school to creepy stories about monsters and creatures and ghosts. The real spine-tingling stuff. Everyone agreed that she was the master.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Kelly glanced around her empty room, suddenly feeling a bit let down. A scary story wasn’t the same when she couldn’t see her friends’ reactions. That was the whole adrenaline rush. The look of pure fear. She couldn’t get that typing on a screen. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("This no-sleepover thing stinks,")]), _vm._v(" she thought. Everything was ready. Her green flannel sleeping bag was rolled out on her floor, with a plastic bag of scares tucked underneath. A fake fuzzy mouse to ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("slip under June’s pillow. A book of ghost stories. A tiny, handheld device that emitted bloodcurdling screams and vicious growls. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("It would have been perfect,")]), _vm._v(" Kelly thought. She didn’t want to wait until next week.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("That was when she had a brilliant idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET’S HAVE A WEBCAM SLEEPOVER TONIGHT")]), _vm._v(". A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL OF US")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SpenceX77: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT’S THAT")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UST LIKE A REAL ONE BUT VIRTUAL")]), _vm._v(". W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ALL PUT ON OUR WEBCAMS SO WE CAN SEE EACH OTHER AND JUST HANG LIKE WE WOULD IF WE WERE TOGETHER")]), _vm._v(". E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCEPT WITH THE COMPUTER")]), _vm._v(". S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PENCER CAN HANG TOO")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SpenceX77: E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCELLENT")]), _vm._v("! N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVER BEEN TO A GIRLS’ SLEEPOVER")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT O’CLOCK")]), _vm._v("! W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR PJ’S")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WESOME")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Juney206: C "), _c('span', {
    staticClass: "small"
  }, [_vm._v("U THEN")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFORE YOU GUYS GO")]), _vm._v(", I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAVE TO WARN YOU ABOUT SOMETHING")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paige4peace421: W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T’S SERIOUS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("SpenceX77: S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIT IT OUT")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kookykell2011: G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ET READY TO BE SCARED")]), _vm._v("! V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERY SCARED")]), _vm._v("!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 69
// module chunks = 0